import { instance } from './index';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import moment from 'moment';

const contextPath = '/admin/supplies';

export const useGetSuppCategoryList = (param) => {
    const sendParam = {
        is_use : param && param.is_use > -1 ? param.is_use : undefined,
    }
    return useQuery('SUPP_CATEGORY_LIST', () => getCategoryList());
}

const getCategoryList = async (param) => {
    const retVal = await instance.get(contextPath+'/categoryList', {params:param})
                                    .then((res)=>{
                                        return res.data;
                                    })
    return retVal;
}

export const useGetSuppList = (param) => {
    const sendParam = {
        cid : param && param.cid > -1 ? param.cid : undefined,
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        sup_cd : param && param.sup_cd !== ''  ? param.sup_cd : undefined,
        sup_st : param && param.sup_st !== ''  ? param.sup_st : undefined,
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('SUPP_LIST', () => getSuppList(sendParam));
}

const getSuppList = async (param) => {
    const retVal = await instance.get(contextPath+'/supplies', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
    return retVal;
}

export const useSetSupplies = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postSupply(sendParam);
                case 'POST_LIST':
                    return postSupplies(sendParam);
                case 'PUT':
                    return putSupply(sendParam);
                case 'DELETE':
                    return deleteSupply(sendParam);
                default :
                    return putSupply(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('SUPP_LIST', { refetchInactive: true })
            },
        }
    )
}

const postSupply = async (param) => {

    const sendParam = {
        cid: param.cid,
        model_nm: param.model_nm,
        model_sub: param.model_sub,
        lot_no: param.lot_no,
        spec: param.spec,
        sup_cd: param.sup_cd,
        sup_st: param.sup_st,
        pur_date: param.pur_date,
        uid: param.uid,
        contents: param.contents,
        descr: param.descr,
    }

    const retVal = await instance.post(contextPath+'/supply', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const postSupplies = async (param) => {

    const sendParam = {
        cnt: param.cnt,
        cid: param.cid,
        model_nm: param.model_nm,
        model_sub: param.model_sub,
        lot_no: param.lot_no,
        spec: param.spec,
        sup_cd: param.sup_cd,
        sup_st: param.sup_st,
        pur_date: param.pur_date,
        uid: param.uid,
        contents: param.contents,
        descr: param.descr,
    }

    const retVal = await instance.post(contextPath+'/supplies', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putSupply = async (param) => {

    const sendParam = {
        sid: param.sid,
        cid: param.cid,
        model_nm: param.model_nm,
        model_sub: param.model_sub,
        lot_no: param.lot_no,
        spec: param.spec,
        sup_cd: param.sup_cd,
        sup_st: param.sup_st,
        pur_date: param.pur_date,
        uid: param.uid,
        contents: param.contents,
        descr: param.descr,
    }

    const retVal = await instance.put(contextPath+'/supply', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const deleteSupply = async (param) => {

    const sendParam = {
        sid: param.sid,
    }

    const retVal = await instance.put(contextPath+'/delSupply', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}